import type { LucideIcon } from 'lucide-react';
import {
  Activity,
  BarChart3,
  Building2,
  ClipboardList,
  Coins,
  Gauge,
  Gift,
  Home,
  Search,
  Settings,
  Store,
  Trophy,
  UserCog,
  Users,
} from 'lucide-react';

export type AdminSurface = 'system_admin' | 'franchise_admin' | 'pub_admin';
export type AdminRole = 'platform_admin' | 'super_admin' | 'staff_admin';

export interface AdminNavItem {
  path: string;
  label: string;
  description: string;
  icon: LucideIcon;
}

export interface AdminSurfaceConfig {
  surface: AdminSurface;
  allowedRole: AdminRole;
  title: string;
  shortTitle: string;
  badge: string;
  loginTitle: string;
  loginDescription: string;
  usernameLabel: string;
  usernamePlaceholder: string;
  homePath: string;
  navItems: AdminNavItem[];
}

export const systemAdminNavItems: AdminNavItem[] = [
  { path: '/', label: '홈', description: '플랫폼 현황', icon: Home },
  { path: '/franchises', label: '프랜차이즈', description: '프랜차이즈 관리', icon: Building2 },
  { path: '/stores', label: '매장', description: '매장 관리', icon: Store },
  { path: '/users', label: '사용자', description: '고객 및 관리자', icon: Users },
  { path: '/oc', label: 'OC', description: 'OC 발행/조정', icon: Coins },
  { path: '/audit', label: '감사 로그', description: '고위험 작업 추적', icon: ClipboardList },
  { path: '/analytics', label: '분석', description: '플랫폼 지표', icon: BarChart3 },
  { path: '/settings', label: '설정', description: '시스템 설정', icon: Settings },
];

export const franchiseAdminNavItems: AdminNavItem[] = [
  { path: '/', label: '홈', description: '프랜차이즈 현황', icon: Home },
  { path: '/stores', label: '매장 비교', description: '매장별 활동 비교', icon: Store },
  { path: '/users', label: '매장 관리자', description: '매장 관리자 계정', icon: UserCog },
  { path: '/customers', label: '고객 활동', description: '고객 활동 요약', icon: Search },
  { path: '/oc', label: 'OC 상태', description: 'OC 현황/요청', icon: Coins },
  { path: '/reports', label: '리포트', description: '운영 리포트', icon: BarChart3 },
];

export const pubAdminNavItems: AdminNavItem[] = [
  { path: '/', label: '홈', description: '매장 운영 현황', icon: Home },
  { path: '/buy-in', label: '바이인', description: '바이인/리바이인 처리', icon: Gauge },
  { path: '/prize', label: '상금', description: '상금 지급', icon: Trophy },
  { path: '/bonus', label: '보너스', description: '보너스 지급/취소', icon: Gift },
  { path: '/tournaments', label: '토너먼트', description: '토너먼트 운영', icon: Activity },
  { path: '/customers', label: '고객', description: '매장 고객 조회', icon: Users },
  { path: '/history', label: '운영 이력', description: '처리 기록', icon: ClipboardList },
];
